import { useQuery } from 'react-query';

// import adm
import adminAxiosInstance from 'services/API/ADMINAPI';
// our api urls
import { getPylonAuthUrl } from 'shared/api-urls';

// our query keys
import { PYLON_CLIENT_ID } from 'shared/query-keys';

function useGetClientPylonId(
	{ clientId, loanId },
	enabled = false
) {
	return useQuery(
		[PYLON_CLIENT_ID, clientId, loanId],
		async () => {
			const res = await adminAxiosInstance.get(
				`${getPylonAuthUrl}?client-id=${clientId}`
			);
			return res.data;
		},
		{
			enabled,
			cacheTime: 0,
			staleTime: 0
		}
	);
}

export default useGetClientPylonId;
